import { render, staticRenderFns } from "./ButtonTarget.vue?vue&type=template&id=2e1b73c0&scoped=true&"
import script from "./ButtonTarget.vue?vue&type=script&lang=js&"
export * from "./ButtonTarget.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTarget.vue?vue&type=style&index=0&id=2e1b73c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b73c0",
  null
  
)

export default component.exports